export function matchesSearch(record, query, keys) {
  const text = query.trim().toLowerCase();
  if (!text) return true;
  return keys.some((key) => String(record[key] ?? "").toLowerCase().includes(text));
}

export function searchableRoutine(routine, log, status) {
  return {
    roomNumber: routine.roomNumber,
    teacherName: routine.teacherName,
    className: routine.className,
    sectionName: routine.sectionName,
    subjectName: routine.subjectName,
    scheduledIn: routine.scheduledIn,
    scheduledOut: routine.scheduledOut,
    day: Array.isArray(routine.days) ? routine.days.join(" ") : routine.day,
    status,
    actualIn: log?.actualIn,
    actualOut: log?.actualOut
  };
}
